import { render, staticRenderFns } from "./joinclazzdata.vue?vue&type=template&id=35f6d846&scoped=true&"
import script from "./joinclazzdata.vue?vue&type=script&lang=js&"
export * from "./joinclazzdata.vue?vue&type=script&lang=js&"
import style0 from "./joinclazzdata.vue?vue&type=style&index=0&id=35f6d846&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6d846",
  null
  
)

export default component.exports